export default __webpack_public_path__ + "static/ELDP-S3-XS-SM-4e7d6e2f221ec2a199ad33f2185bb812.webp";